import { Operator } from '@jexop/core';
import { isDate, isString } from 'lodash';
import { DateTime } from 'luxon';
import { Nullable } from '../types';
import { formatDateTimePeriod } from '../util';

type DateFormat = 'short' | 'long' | 'narrow';

export const formatDatePeriod: Operator<string> = ({ start, end, format }): Nullable<string> => {
  const dateFormat = format as DateFormat;

  if ((!isString(start) && !isDate(start)) || (!isString(end) && !isDate(end))) {
    return null;
  }

  const startDate = isString(start) ? DateTime.fromISO(start) : DateTime.fromJSDate(start);
  const endDate = isString(end) ? DateTime.fromISO(end) : DateTime.fromJSDate(end);

  if (!startDate.isValid || !endDate.isValid) {
    return null;
  }

  return formatDateTimePeriod(startDate.toJSDate(), endDate.toJSDate(), dateFormat);
};
